<div class="featuredproperties be-data-entry-page" *ngIf="!isShowAnalyze">
  <div class="container container-lg min-heightcontainer table-fixed">
    <div class="border-div no-shadow" style="padding-top:0;">
      <div class="row">
        <app-my-portfolio-summary [UserGuid]="UserGuid" [propertyListingAnalyze]="getAnalyzeMethod()"></app-my-portfolio-summary>
      </div>
      <div class="floatinghead floatinghead-xs clearfix margin-bottom-15">
        <div class="row">
          <div class="col-md-12">
            <h3 class="bluelabel margin-bottom-0 margin-top-10 cf margin-bottom-15">My Properties</h3>
          </div>
          <!--<div class="col-md-8">
            <div class="button-right cf">-->
              <!--<button class="right-btn btn btn-lg btn-addyellow margin-bottom-15 margin-left-15" (click)="Analyze();">ANALYZE PORTFOLIO</button>-->
              <!--<button class="right-btn btn btn-lg btn-addgreen margin-bottom-15" (click)="openAddNewProperty()"> + ADD PROPERTY</button>
            </div>
          </div>-->
        </div>
      </div>
      <div class="table-responsive">
        <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
          <thead>
            <tr>
              <th data-orderable="false">
                <label class="custom-checkbox withoutlabel">
                  <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>
                </label>
              </th>
              <th data-orderable="false" class="whitespacenowrap">Action</th>
              <th style="display:none" class="min-width-td">Guid</th>
              <th style="width:10px;" class="min-width-td" [hidden]="true">Property Id</th>
              <th style="width:150px;" class="min-width-td">Tenant</th>
              <th>State</th>
              <th class="min-width-75">City</th>
              <th class="min-width-75">Status</th>
              <th class="whitespacenowrap">Lease Type</th>
              <th>Rent / NOI</th>
              <th>Remaining Term</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of propertyList;let i = index ">
              <tr [class.portfoio-list]="item.IsPortfolio">
                <td>
                  <label *ngIf="!item.IsPortfolio" class="custom-checkbox withoutlabel">
                    <input type="checkbox" [(ngModel)]="item.IsSelected" (change)="onCheckboxChange($event.target.checked,item.Id, item.Type);" class="ng-pristine ng-valid ng-touched"><i></i>
                  </label>
                </td>
                <td style="white-space:nowrap;">
                  <a *ngIf="item.IsCreated == 1&&(item.PropertyStatus=='Portfolio' ||item.PropertyStatus=='Rejected')" href="javascript:void(0);" routerLink="/portfolio-principal-property/{{item.Guid}}" [queryParams]="{prevroute:linkname,link:link, isPortfolio:item.IsPortfolio,UserGuid:this.UserGuid}" class="blueone" tooltip="Edit" placement="right">
                    <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                  </a>
                  <a class="remove" tooltip="Remove" href="javascript:void(0);" *ngIf="item.IsCreated == 1&&item.PropertyStatus=='Portfolio'&&IsmyPortfolio" (click)="openModal(template,'deletemodal',item.Guid,item.PropertyName,i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                  <a class="blueone" tooltip="Request Change" href="javascript:void(0);" *ngIf="item.IsCreated == 1&&(item.PropertyStatus!='Portfolio'&&item.PropertyStatus!='Rejected') && item.CanEditProperty == 1" (click)="openModalForEditApprove(ApproveEdit,'panlestyle',item.Guid,item.PropertyName)"><i class="icofont icofont-loop" aria-hidden="true"></i></a>
                  <a class="remove" tooltip="Make Off-Market" href="javascript:void(0);" *ngIf="(item.PropertyStatus=='Portfolio'||item.PropertyStatus=='Rejected')&&item.DataEntryPropertyStatusId!=6949" (click)="OnClickOffMarket(item.Id,PropertyOffMarketModal,'property-Offmarket',item)"><i class="fa fa-dollar" aria-hidden="true"></i></a>

                </td>
                <td [hidden]="true">
                  <p class="d-flex">
                    {{item.PropertySequenceId ? item.PropertySequenceId : '-'}}
                  </p>
                </td>
                <td class="sticky-left first-td">
                  <p class="d-flex whitespacenowrap">
                    <span style="position:static;margin-right:5px;" container="body" *ngIf="item.IsPortfolio&&item.IsCreated == 1 && item.PortfolioPropertyCount > 0" (click)="showPortfolioProperties(item.Id, i)" class="btn-collapse" tooltip="Portfolio" [class.span-open]="this.propertyList[i].ShowPortfolioProperties">
                      <img src="/assets/img/portfolio.svg">
                    </span>
                    <span style="position:static;margin-right:5px;" *ngIf="item.IsPortfolio&&item.IsCreated == 1 && item.PortfolioPropertyCount > 0" (click)="showPortfolioProperties(item.Id, i)" class="btn-collapse" [class.span-open]="this.propertyList[i].ShowPortfolioProperties">
                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                    <span container="body" style="position:static;margin-right:5px;" *ngIf="item.IsPortfolio&&item.IsCreated == 1 && item.PortfolioPropertyCount == 0" tooltip="Portfolio">
                      <img src="/assets/img/portfolio.svg">
                    </span>
                    <a *ngIf="item.IsPortfolio" href="javascript:void(0);" routerLink="/seller/dashboard" [queryParams]="{UserGuid: UserGuid,'prevroute':linkname}">
                      {{ item.PropertyName }}
                    </a>
                    <span container="body" style="position:static;margin-right:5px;" *ngIf="!item.IsPortfolio&& item.PortfolioPropertyId != null" tooltip="Portfolio Property">
                      <img src="/assets/img/single-property.svg">
                    </span>
                    <a *ngIf="!item.IsPortfolio" href="javascript:void(0);" routerLink="/property-detail/{{item.Guid}}" [queryParams]="{'iscreated':item.IsCreated,UserGuid: UserGuid,'prevroute':linkname}">{{ item.PropertyName }}</a>
                    <!--</p><sub>{{item.PropertySequenceId}}</sub>-->
                  <p>{{item.Address}}</p>
                </td>
                <td>
                  <p>{{item.StateName ? item.StateName : '-'}}</p>
                </td>
                <td>
                  <p>{{item.CityName ? item.CityName : '-'}}</p>
                </td>
                <td><p [ngClass]="{'redtextlabel':(item.PropertyStatus === 'Closed' || item.PropertyStatus === 'Sold'),'greentextlabel':item.PropertyStatus === 'Available','orangetextlabel':item.PropertyStatus === 'Under Contract','not-available':item.PropertyStatus === 'Not Available','Off-Market':(item.PropertyStatus === 'Off-Market'||item.PropertyStatus==='Portfolio'), 'darkbluetextlabel':item.PropertyStatus === 'Pending Approval'}">{{ (item.PropertyStatus=='Portfolio'&&item.DataEntryPropertyStatusId==6949)?'Portfolio(Draft)':item.PropertyStatus }}</p></td>
                <td>
                  <p>{{item.LeaseType ? item.LeaseType : '-'}}</p>
                </td>
                <td>
                  <!--<p class="whitespacenowrap" *ngIf="item.NOI">Unpriced</p>-->
                  <p class="whitespacenowrap">{{(item.NOI) ? '$ '+ (item.NOI | number:0) : '-'}}</p>
                </td>
                <td>
                  <p>{{item.RemainingTerm ? item.RemainingTerm : '-'}}</p>
                </td>
              </tr>
              <ng-container *ngIf="this.propertyList[i].ShowPortfolioProperties">
                <tr *ngFor="let propChild of item.PortfolioProperties; let k=index" (click)="selecteRow(k)" [class.tr-collapse]="this.propertyList[i].ShowPortfolioProperties">
                  <td>
                  </td>
                  <td>
                  </td>
                  <td class="sticky-left first-td">
                    <p class="d-flex">
                      <a href="javascript:void(0);" routerLink="/property-detail/{{propChild.Guid}}" [queryParams]="{'iscreated':item.IsCreated,UserGuid: UserGuid,'prevroute':linkname}">{{ propChild.PropertyName }}</a>
                    <p>{{propChild.Address}}</p>
                  </td>
                  <td>
                    <p>{{propChild.StateName ? propChild.StateName : '-'}}</p>
                  </td>
                  <td>
                    <p>{{propChild.CityName ? propChild.CityName : '-'}}</p>
                  </td>
                  <td><p [ngClass]="{'redtextlabel':(propChild.PropertyStatus === 'Closed' || propChild.PropertyStatus === 'Sold'),'greentextlabel':propChild.PropertyStatus === 'Available','orangetextlabel':propChild.PropertyStatus === 'Under Contract','not-available':propChild.PropertyStatus === 'Not Available','Off-Market':propChild.PropertyStatus === 'Off-Market', 'darkbluetextlabel':propChild.PropertyStatus === 'Pending Approval'}">{{propChild.PropertyStatus ? propChild.PropertyStatus : '-' }}</p></td>
                  <td>
                    <p>{{propChild.LeaseType ? propChild.LeaseType : '-'}}</p>
                  </td>
                  <td class="whitespacenowrap">
                    <p>{{(propChild.NOI) ? '$ '+ (propChild.NOI | number:0) : '-'}}</p>
                  </td>
                  <td>
                    <p>{{propChild.RemainingTerm ? propChild.RemainingTerm : '-'}}</p>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
          <tfoot>
            <tr *ngIf="propertyList?.length == 0 &&!IsLoading">
              <td colspan="10" class="odd no-data-available">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No Properties Available</p>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

  </div>
</div>
<div *ngIf="isShowAnalyze">

  <div class="comparisonpage section-margin" *ngIf="!showNodata && isShowAnalyze">
    <div class="container  analysis-wrap  min-heightcontainer">
      <div class="border-div be-white-box" style="background:#fff;">
        <div class="headings clearfix">
          <h3 class="bleckhead">Portfolio Analysis</h3>
          <div class="right" *ngIf="analyzeId==0">
            <button class="btn btn-sm btn-border" (click)="analyze(true)">Analyze</button>
            <button [disabled]="disableAdd" class="btn btn-circle btn-green" tooltip="Add Property" (click)="openModalForAddProperty(template,'commonmodal addPropertyAnalyze')" placement="top">
              <i class="icofont icofont-plus icon"></i>
            </button>
          </div>
        </div>

        <div class="pos-relative margin-bottom-40">
          <div class="table-responsive  fixedcolumn-table PropertyComparison-table" [ngClass]="{'without-rightfixedcolumn':(isPropertyAnalysis)}">
            <table class="table basictable noborder ">
              <tbody>
                <tr>
                  <td class="thstyle padding0 fixedtd" style="width:150px;">
                    <table class="table ">
                      <tbody>
                        <tr>
                          <td class="thstyle firsttd">Tenants</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Acquisition Price</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Rent / NOI</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Cap Rate</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Credit Rating</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Return During Lease</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Rent Escalations</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Remaining Term</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Building Size(Sq Ft)</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Land(Acr)</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Year Built</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Lease Structure</td>
                        </tr>
                        <tr>
                          <td class="thstyle">Ownership Type</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td class="padding0 tdwidth" *ngFor="let item of comparePropertyDetailModelList">
                    <table class="table ">
                      <tbody>
                        <tr>
                          <td class="firsttd">
                            <div class="propertycheckbox">
                              <label class="custom-checkbox iconallignment">
                                <input ng-reflect-model="false" id="0" class="ng-pristine ng-valid ng-touched" (change)="chekAnalyzeProperty(item,validationTemplate, '')" [(ngModel)]="item.IsChecked" type="checkbox">
                                <i></i>{{item.PropertyName}}
                              </label>
                              <button *ngIf="comparePropertiesModel.IsOfferPortfolio" class="delete-property" (click)="deleteAnalyzeProperty(item)"><i class="fa fa-times"></i></button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="rate-caculator" [ngStyle]="{'font-weight' : this.maxCompareValues.MaxAcquisitionPrice==item.AcquisitionPrice ? 'bold' : 'normal'}">
                            <div class="textbox-with-btn-left">
                              <input type="text" [(ngModel)]="item.AcquisitionPrice" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"
                                     dropSpecialCharacters="false" class="form-control " value="{{item.AcquisitionPrice|number:0}}" (keyup)="onAcquisitionPriceChange(item.PropertyId,item.AcquisitionPrice)">
                              <span class="leftlabel">$</span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxNOI==item.NOI ? 'bold' : 'normal'}">{{item.NOI!=null && item.NOI!=0?'$ '+ (item.NOI|number):'-'}}</td>
                        </tr>
                        <tr>
                          <td>
                            <div class="textbox-with-btn textbox-with-2character">
                              <input type="number" min=0 [(ngModel)]="item.CapRate" dropSpecialCharacters="false" (keyup)="onCapRateChange(item.PropertyId,item.CapRate)" class="form-control acquisitionCalculator">
                              <span class="rightlabel">%</span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>{{item.Rating!=null?item.Rating:'-'}}</td>
                        </tr>
                        <tr>
                          <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxReturnDuringPrice==item.ReturnDuringPrice ? 'bold' : 'normal'}">{{item.ReturnDuringPrice!=0?'$ '+ (item.ReturnDuringPrice|number):'-'}}</td>
                        </tr>
                        <tr>
                          <td>{{item.RentEscalations}}</td>
                        </tr>
                        <tr>
                          <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxRemainingTerm==item.RemainingTerm ? 'bold' : 'normal'}">{{item.RemainingTerm | yearsMonthConverter:true}}</td>
                        </tr>
                        <tr>
                          <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxBuildingSize==item.BuildingSize ? 'bold' : 'normal'}">{{item.BuildingSize!=0 && item.BuildingSize!=null?(item.BuildingSize|number):'-'}}</td>
                        </tr>
                        <tr>
                          <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxLand==item.Land ? 'bold' : 'normal'}">{{item.Land!=0 && item.Land!=null?(item.Land|number):'-'}}</td>
                        </tr>
                        <tr>
                          <td [ngStyle]="{'font-weight' : this.maxCompareValues.MaxYearBuilt==item.YearBuilt ? 'bold' : 'normal'}">{{item.YearBuilt}}</td>
                        </tr>
                        <tr>
                          <td>{{item.LeaseStructure}}</td>
                        </tr>
                        <tr>
                          <td>{{item.OwnershipType}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td class="padding0 tdwidth fixedtdlast" *ngIf="!isPropertyAnalysis">
                    <table class="table ">
                      <tbody>
                        <tr>
                          <td style="vertical-align:top" class="firsttd"><p><strong>Total/Avg</strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong>{{'$ '+ (comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg| number:0)}}</strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong>{{'$ '+ (comparePropertyDataTotalOrAvgModel.NOITotalOrAvg|number)}}</strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong>{{comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg!=null?(comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg) + '% / Avg':'-'}}</strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong></strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong>{{'$ '+(comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal|number)}}</strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong></strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong>{{comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg!=0?((comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg | yearsMonthConverter:true) +' / Avg'):'-'}}</strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong>{{comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg!=0?(comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg|number):'-'}}</strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong>{{comparePropertyDataTotalOrAvgModel.LandTotalOrAvg!=0?(comparePropertyDataTotalOrAvgModel.LandTotalOrAvg|number):'-'}}</strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong></strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong></strong></p></td>
                        </tr>
                        <tr>
                          <td><p><strong></strong></p></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="headings clearfix" id="divAnalytics">
          <h3 class="bleckhead" *ngIf="isAnalyze">Analytics</h3>
        </div>

        <div id="capture">
          <div class="row chartbox-allignment">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild" [hidden]="true">
              <div class="border-div box-height">
                <div class="floatinghead clearfix">
                  <h2 class="mainhead">
                    <span class="text">Price</span>
                  </h2>
                  <div class="col-lg-12">
                    <h5 *ngIf="!isPropertyAnalysis" class="rightvalue whitespacenowrap">{{'$ '+ (comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg|number)}}</h5>
                    <div class="ct" id="priceChart"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
              <div class="border-div box-height">
                <div class="floatinghead clearfix">
                  <h2 class="mainhead">
                    <span class="text">Land Area</span>
                  </h2>
                  <div class="col-lg-12">
                    <div class="ct" id="landAreaChart"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
              <div class="border-div box-height">
                <div class="floatinghead clearfix">
                  <h2 class="mainhead">
                    <span class="text">NOI</span>
                  </h2>
                  <div class="col-lg-12">
                    <h5 *ngIf="!isPropertyAnalysis" class="rightvalue whitespacenowrap">{{comparePropertyDataTotalOrAvgModel.NOITotalOrAvg!=0?('$ '+ (comparePropertyDataTotalOrAvgModel.NOITotalOrAvg|number)):'-'}}</h5>
                    <div class="ct" id="NOIChart"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row  chartbox-allignment">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
              <div class="border-div box-height">
                <div class="floatinghead clearfix">
                  <h2 class="mainhead">
                    <span class="text">Cap Rate</span>
                  </h2>
                  <div class="col-lg-12">
                    <h5 *ngIf="!isPropertyAnalysis" class="rightvalue whitespacenowrap">{{comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg!=null?(comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg+ '% / Avg'):'-'}}</h5>
                    <div class="ct" id="capRateChart"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
              <div class="border-div box-height">
                <h2 class="mainhead">
                  <span class="text">Remaining Term</span>
                </h2>
                <div class="col-lg-12">
                  <div class="ct" id="remainingTermChart"></div>
                </div>
              </div>
            </div>
          </div>


          <div class="row chartbox-allignment">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
              <div class="border-div box-height">
                <h2 class="mainhead">
                  <span class="text">Credit Rating</span>
                </h2>
                <div class="ct" id="creditRatingChart"></div>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
              <div class="border-div box-height">
                <div class="floatinghead clearfix">
                  <h2 class="mainhead">
                    <span class="text">Return During Lease</span>
                  </h2>
                  <div class="col-lg-12">
                    <h5 *ngIf="!isPropertyAnalysis" class="rightvalue whitespacenowrap">{{comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal!=0?('$ '+ (comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal|number)):'-'}}</h5>
                    <div class="ct" id="returnDuringLeaseChart"></div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="border-div margin0" *ngIf="isAnalyze">
            <div class="box-height">
              <div class="floatinghead clearfix">
                <h2 class="mainhead">
                  <span class="text">Projected Revenue - Portfolio</span>
                </h2>
                <div class="col-lg-12">
                  <label class="custom-checkbox floatingheadCheckbox margin-right-20" *ngIf="!isPropertyAnalysis">
                    <input type="checkbox" [(ngModel)]="enableExtendedChart" (change)="bindRevenueChart()">
                    Total NOI with Options
                    <i></i>
                  </label>
                  <div class="ct" id="revenueChart"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="margin-top-20">
          <div class="row" *ngIf="isAnalyze">
            <div class="colg-6 col-md-4 col-sm-5 col-xs-12">
              <button class="btn btn-lg btn-border margin-bottom-15" data-html2canvas-ignore (click)="pdfDownload()">Download as PDF</button>
            </div>
            <div class="colg-6 col-md-8 col-sm-7 col-xs-12 text-right" *ngIf="analyzeId==0">
              <button class="btn btn-lg btn-border margin-bottom-15" *ngIf="analyzeId==0" (click)="Back()">Back</button>
            </div>
            <div class="colg-6 col-md-8 col-sm-7 col-xs-12 text-right" *ngIf="analyzeId!=0">
              <button class="btn btn-lg btn-border margin-bottom-15" (click)="Cancel()">Back</button>
            </div>

          </div>
        </div>



        <ng-template #template class="pull-left">

          <div class="modal-header">
            <h4 class="modal-title pull-left">Add Properties</h4>
            <button aria-label="Close" class="close pull-right" (click)="modalRef.hide()" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="clearfix"></div>
          </div>
          <div class="modal-body">
            <ul class="properties-analyse">
              <li *ngFor="let item of addPropertyList">
                <label class="custom-checkbox withoutlabel">
                  <input type="checkbox" [(ngModel)]="item.IsChecked" (change)="onAddPropertyChecked(item);"><i></i>
                </label>
                <label class="property-name">
                  {{item.PropertyName}} - {{item.CityName}} , {{item.StateName}}
                </label>
                <ul class="listing clearfix">
                  <li>
                    <h5>CAP</h5>
                    <h6 *ngIf="item.CharacteristicsId == 1">ZCF</h6>

                    <h6 *ngIf="item.CharacteristicsId != 1">{{item.CapRate!=null && item.CapRate!=0 ?((item.CapRate)+'%'):'-'}}</h6>
                  </li>
                  <li>
                    <h5>Rating</h5>
                    <h6>{{item.Rating!=null && item.Rating!=undefined ?(item.Rating):'-'}}</h6>
                  </li>
                  <li>
                    <h5>NOI</h5>
                    <h6>{{item.NOI!=null && item.NOI!=0 ?'$ '+ (item.NOI|number):'-'}}</h6>
                  </li>
                  <li>
                    <h5>Term</h5>
                    <h6>{{item.RemainingTerm}}</h6>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="text-right margin-top-20">
              <button class="btn btn-default btn-lg" (click)="modalRef.hide()">Cancel</button>
              <button class="btn btn-success btn-lg" [disabled]="disableAddButton" (click)="addPropertyInComparisonList()">Add</button>
            </div>
          </div>
        </ng-template>

        <ng-template #cancelTemplate>
          <div class="modal-header">
            <h4 class="modal-title pull-left">Exit</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body padding30">

            <div class="form-group">
              <h6 class="displayvalue">Are you sure you want to cancel ?</h6>
            </div>
            <div class="text-right">
              <button class="btn btn-lg btn-default" (click)="modalRef.hide()">No</button>
              <a href="javascript:void(0);" class="btn btn-lg btn-success" (click)="cancelSuccess()">Yes</a>
            </div>
          </div>
        </ng-template>



        <ng-template #analysisTemplate>
          <div class="modal-header">
            <h4 class="modal-title pull-left">Save Analysis</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body padding30">

            <div class="form-group">
              <label class="form-label">Analysis Name<span class="red">*</span></label>
              <input class="form-control" [(ngModel)]="comparePropertiesModel.Name" type="text" maxlength="100">
              <p class="redtext" *ngIf="isAnalyzeName">Analysis Name is required </p>
            </div>
            <div class="text-right">
              <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Exit</button>
              <button class="btn btn-lg btn-success" [disabled]="isSaveDisabled" (click)="saveAnalyze()">Save</button>
            </div>
          </div>

        </ng-template>
        <ng-template #validationTemplate>
          <div class="modal-header">
            <h4 class="modal-title pull-left">Exit</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="cancelUncheckProperty()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body padding30">

            <div class="form-group">
              <h6 class="displayvalue">Are you sure you want to uncheck property ?</h6>
            </div>
            <div class="text-right">
              <button class="btn btn-lg btn-default" (click)="cancelUncheckProperty()">No</button>
              <a href="javascript:void(0);" class="btn btn-lg btn-success" (click)="uncheckProperty()">Yes</a>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <!--<app-portfolio-analysis-detail></app-portfolio-analysis-detail>-->
</div>

<ng-template #template>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Property ?</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete {{property}} ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="deleteProperty();modalRef.hide();">Delete</button>
    </div>
  </div>

</ng-template>

<ng-template #BrokerageTemplate>
  <app-brokerage-add [modalRef]="modalRef" [item]="item" (closeModal)="closeModal($event)"></app-brokerage-add>
</ng-template>
<ng-template #BrokerTemplate>
  <app-broker-add [modalRef]="modalRef" [item]="item" (closeModal)="closeModal($event)"></app-broker-add>
</ng-template>
<ng-template #template class="pull-left">
  <app-audit-trail-details [modalRef]="modalRef" [auditTrailId]="AuditId"></app-audit-trail-details>
</ng-template>

<ng-template #DeleteBrokerageTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Brokerages</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Deleting the brokerages will also delete the {{brokersCount}} brokers associated with it. Are you sure you want to proceed ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">No</button>
      <button class="btn btn-lg btn-danger" (click)="DeleteBrokerage()">Yes</button>
    </div>
  </div>
</ng-template>
<ng-template #DeleteBrokerTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Brokers</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue"> Are you sure you want to delete ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">No</button>
      <button class="btn btn-lg btn-danger" (click)="DeleteBroker()">Yes</button>
    </div>
  </div>
</ng-template>
<ng-template #ApproveEdit>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit Property</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">You cannot edit the property as it is in Off-Market status. Please add a comment and the admin will contact you soon</label>
    </div>
    <div class="form-group">
      <label class="form-label">Comments</label>
      <textarea class="form-control" [(ngModel)]="Comments" maxlength="500" rows="3"></textarea>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="EditLiveProperty();">Request Change</button>
    </div>
    <div *ngIf="requestDetail != null && requestDetail != undefined" class="form-group" style="margin-top:20px">
      <label class="form-label">Previous Comment: {{requestedComment}}</label>
      <label class="form-label">Previous Requested Date: {{requestedDate | date:'MM/dd/yyyy'}}</label>
    </div>
  </div>
</ng-template>
<ng-template #QuickEdit>
  <app-quick-edit-myportfolio [selectedPropertyId]="selectedPropertyId" [source]="'statusChange'" [quickEditDetails]="quickEditDetails" (closeModal)="closeModal($event)" [isDataEntryProperty]="isDataEntryProperty"></app-quick-edit-myportfolio>
</ng-template>


<ng-template #bulkAction>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Change Status</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">
        Change Status of selected {{getSelectedCount()}} properties
        <span class="star">*</span>
      </label>
      <label class="select">
        <select [(ngModel)]="statusToChange" #propStatus="ngModel" class="form-control">
          <option value="0">--Select--</option>
          <option [ngValue]="item.id" *ngFor="let item of propertyStatusList">{{item.description}}</option>
        </select>
        <i></i>
      </label>
      <p class="redtext" *ngIf="showSelectStatus || (propStatus.touched && statusToChange == 0)">Please select status</p>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="changeStatus();">Update</button>
    </div>
  </div>

</ng-template>



<ng-template #DuplicateProperty>
  <app-duplicate-property-list [PropertyId]="selectedPropertyIdForDuplicates" [modalRef]="modalRefDuplicates" [Type]="2"></app-duplicate-property-list>
</ng-template>
<ng-template #PropertyOffMarketModal>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Make Property Off-Market</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalOffMarket.hide();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-v2 padding30">
    <h4 class="Offmarket-MainHeading"> Confirm your property details</h4>
    <div class="form-group margin-top-20" *ngIf="pendingProperties!=null && pendingProperties?.length>0">
      <label class="form-label clearfix">
        Property
      </label>
      <label class="select margin-bottom-50">
        <select class="form-control" name="lstProperty" (change)="onPropertyChanges();" [(ngModel)]="selectedPendindId">
          <option [ngValue]="item.Guid" *ngFor="let item of pendingProperties">{{item.TenantName}}{{item.Address!=null?(' - '+item.Address):''}}</option>
        </select>
        <i></i>
      </label>
      <div *ngIf="!IsValid">
        <p class="redtext">
          Property is required
        </p>
      </div>
    </div>

    <div class="margin-top-30" *ngIf="selectedPendingProperty!=null&&selectedPendingProperty.Guid!=null&&selectedPendingProperty.Guid!=''">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group margin-bottom-0">
            <h5 class="displayvalue font-18">{{selectedPendingProperty!=null&&selectedPendingProperty.TenantName!=null?selectedPendingProperty.TenantName:'-'}}</h5>
          </div>
        </div>
      </div>
      <div class="row margin-top-10">
        <div class="col-sm-12">
          <div class="form-group">
            <h6 class="font-16">{{selectedPendingProperty!=null&&selectedPendingProperty.Address!=null?selectedPendingProperty.Address:'-'}}</h6>
          </div>
        </div>
      </div>
      <div class="row margin-top-10" *ngIf="selectedPendingProperty!=null">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="blocklabel">Lease Structure</label>
            <h6 class="displayvalue">{{selectedPendingProperty!=null&&selectedPendingProperty.LeaseStructure!=null?selectedPendingProperty.LeaseStructure:'-'}}</h6>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="blocklabel">Ownership Type</label>
            <h6 class="displayvalue">{{(selectedPendingProperty!=null&&selectedPendingProperty.OwnershipType!=null)?selectedPendingProperty.OwnershipType:'-'}}</h6>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="selectedPendingProperty!=null">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="blocklabel">Net Operting Income</label>
            <h6 class="displayvalue">{{(selectedPendingProperty!=null&&selectedPendingProperty.RentNOI!=null)?('$ ' + Validation.decimalCommaFormat(selectedPendingProperty.RentNOI)):'-'}}</h6>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="blocklabel">Remaining Term</label>
            <h6 class="displayvalue">{{(selectedPendingProperty!=null&&selectedPendingProperty.Remaining_Term!=null&&selectedPendingProperty.Remaining_Term!=undefined)?selectedPendingProperty.Remaining_Term:'-'}}</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right margin-top-30">
      <button type="button" class="btn btn-3x-border btn-small btn-lg btn-property-edit-nobackground margin-right-10" (click)="onclickEditProperty()">EDIT PROPERTY</button>
      <button class="btn btn-lg btn-addgreen" (click)="proceedPricing()"> PROCEED TO PRICING</button>
    </div>
  </div>

</ng-template>
<ng-template #QuickEditPortfolio>
  <app-quick-edit-myportfolio [selectedPropertyId]="selectedPendindId" [propertyBasicDetails]="selectedPendingProperty" [source]="'statusChange'" (closeModal)="closeModal($event)" [isDataEntryProperty]="true" [UserGuid]="UserGuid"></app-quick-edit-myportfolio>
</ng-template>
<button id="openModalChangeToOffMarketButton" [hidden]="true" (click)="openModalForQuickEdit1(QuickEditPortfolio,'property-Offmarket')"></button>

